/**
 * Registration page.
 *
 * Adults only — there are no child accounts (§14), so the copy is written for an
 * adult creating their own account. Real email verification arrives in Phase 2;
 * the mock marks a new account unverified and routes to the dashboard.
 */

import { el, icon, fieldValue } from "../ui/dom.js";
import { pageHeader, errorAlert } from "../ui/patterns.js";

/** @type {import("../app/router.js").PageRenderer} */
export default function renderRegister(context) {
  const frag = document.createDocumentFragment();
  frag.append(
    pageHeader(
      "Create an account",
      "You must be 18 or over to create a KinCode account. KinCode is for adults " +
        "managing their own contacts.",
    ),
  );

  const errorRegion = el("div", { "aria-live": "assertive" });

  const emailField = el("wa-input", {
    label: "Email address",
    name: "email",
    type: "email",
    autocomplete: "email",
    required: true,
  });

  const passwordField = el("wa-input", {
    label: "Choose a password",
    hint: "Use at least 12 characters.",
    name: "password",
    type: "password",
    autocomplete: "new-password",
    "password-toggle": true,
    required: true,
  });

  const submit = el("wa-button", { type: "submit", variant: "brand" }, [
    icon("user"),
    "Create account",
  ]);

  const form = el(
    "form",
    {
      class: "kin-stack kin-form",
      novalidate: true,
      on: {
        submit: async (event) => {
          event.preventDefault();
          errorRegion.replaceChildren();
          submit.setAttribute("loading", "");
          try {
            await context.services.auth.register(fieldValue(emailField), fieldValue(passwordField));
            context.navigate("/dashboard");
          } catch (error) {
            submit.removeAttribute("loading");
            errorRegion.replaceChildren(
              errorAlert(error instanceof Error ? error.message : "Registration failed."),
            );
          }
        },
      },
    },
    [emailField, passwordField, submit],
  );

  frag.append(
    errorRegion,
    form,
    el("p", { class: "kin-note" }, [
      "Already have an account? ",
      el("a", { href: "/sign-in", dataset: { link: "" } }, ["Sign in"]),
      ".",
    ]),
  );
  return frag;
}
